<template>
  <div>
    <Modal v-model="modelShow" title="物流任务列表" @on-cancel="cancel" width="900">
      <datagrid v-if="pickShow" :columns="colsPick" :pagination="false" :autoLoad="false" subListName :dataList="dataList">
        <template #default="{columns, data}">
          <Table :columns="columns" :data="data" border stripe size="small">
            <template #fileList="{row,index}">
              <a v-for="(item,index) in row.fileList" :key="index" style="padding-left:20px" @click="onDownloadFile(pltUtil.downloadUrl()+item.fileId)" :title="item.name">{{item.name.trim().length < 10?item.name.trim():item.name.substr(0,10)+'...'}}</a>
            </template>
          </Table>
        </template>
      </datagrid>
      <div slot="footer">
        <Button type="primary" @click="cancel">关闭</Button>
      </div>
      <preview-image ref="previewImageRef" />
    </Modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      modelShow: false,
      pickShow: true,
      dataList: [],
      colsPick: [
        {
          title: "物流公司",
          key: "logisticCorpId",
          dict: ["bizObjects", "member", true],
        },
        {
          title: "司机姓名",
          key: "linkmanId",
          dict: ["bizObjects", "contact", true],
        },
        { title: "车牌号", key: "plateNo" },
        { title: "计划数量", key: "planQty" },
        { title: "实际出库数量", key: "shippingQty" },
        { title: "签收数量", key: "receiveQty" },
        { title: "签收时间", key: "receiveDate", formatter: "date" },
        { title: "附件列表", slot: "fileList" },
      ],
    };
  },
  methods: {
    onDownloadFile(url) {
      var tempwindow = window.open("_blank");
      tempwindow.location = `${url}&disposition=inline`;
    },
    openModal(id) {
      this.modelShow = true;
      this.getList(id);
    },
    cancel() {
      this.modelShow = false;
    },
    getList(logisticsTaskId) {
      let data = {
        url: "http://MID-OPERATE-LOGISTICS/messageService/queryService/queryLogisticsSubTasksForDelivery",
        body: { logisticsTaskId },
      };
      this.pickShow = false;
      this.invoke(data).then((res) => {
        this.dataList = res;
        this.pickShow = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>